<template>
    <div class="pt-2 pb-6 md:py-6">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <h1 class="text-2xl font-semibold text-gray-900">
                <SmartBreadcrumbs
                    :pages="[
                        {
                            name: $t('messages.preferences'),
                            href: null,
                        },
                    ]"
                />
            </h1>
        </div>
        <div class="max-w-7xl mx-auto md:px-4 sm:px-6 md:px-8">
            <UpdateActivityPreferencesForm :activity="activity" :url="meta.links.update" />
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import UpdateActivityPreferencesForm from '@/components/UpdateActivityPreferencesForm.vue';

export default {
    components: {
        UpdateActivityPreferencesForm,
    },
    layout: Layout,
    name: 'Edit',
    props: ['activity', 'meta'],
};
</script>
